import React, { useMemo, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import Papa from "papaparse";
import DateRangeReport from "../../../../components/DateRangeReport";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import SelectSearch from "../../../../components/SelectSearch";
import getCustomerCategoriesCount from "./CustomerCategoriesCount";

function CustomerCountPage({
  transactions,
  onChangeDate,
  onChangeStore,
  dateField,
  store,
  storess,
  range,
  notFound,
}) {
  const [selectedStore, setSelectedStore] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getUniqueStores = (transactions) => {
    const storeSet = new Set();
    transactions.forEach((transaction) => {
      const storeCode = transaction.store_code.replace("ANGELSPIZZA_", "");
      storeSet.add(storeCode);
    });
    return Array.from(storeSet);
  };

  const filteredTransactions = useMemo(() => {
    return transactions.filter((transaction) => {
      const tranDate = new Date(transaction.tran_date);
      const start = startDate ? new Date(startDate) : new Date(0); // Unix epoch start if empty
      let end = endDate ? new Date(endDate) : new Date(); // Current date if empty
      end.setHours(23, 59, 59, 999); // Set the end date to the end of the day

      return tranDate >= start && tranDate <= end;
    });
  }, [transactions, startDate, endDate]);

  const uniqueStores = useMemo(
    () => getUniqueStores(filteredTransactions),
    [filteredTransactions]
  );

  const customerCategories = useMemo(
    () => getCustomerCategoriesCount(filteredTransactions, selectedStore),
    [filteredTransactions, selectedStore]
  );

  const loyalistCount = customerCategories.loyalists.length;
  const potentialLoyalistCount = customerCategories.potentialLoyalists.length;
  const promisingCount = customerCategories.promising.length;
  const hesitantCount = customerCategories.hesitant.length;
  const needAttentionCount = customerCategories.needAttention.length;
  const detractorsCount = customerCategories.detractors.length;
  const customerCount = customerCategories.customerCount;

  const data = {
    labels: [
      "Loyalist",
      "Potential Loyalist",
      "PROMISING",
      "HESITANT",
      "NEED ATTENTION",
      "DETRACTORS",
      // "CUSTOMERS",
    ],
    datasets: [
      {
        label: "Customer Count per Customer Type",
        data: [
          loyalistCount,
          potentialLoyalistCount,
          promisingCount,
          hesitantCount,
          needAttentionCount,
          detractorsCount,
          // detractorsCount + filteredTransactions.length,
          // filteredTransactions.length,
        ],
        backgroundColor: [
          "#00589C",
          "#016FC4",
          "#1891C3",
          "#3AC0DA",
          "#3DC6C3",
          "#50E3C2",
        ],
        borderColor: [
          "#00589C",
          "#016FC4",
          "#1891C3",
          "#3AC0DA",
          "#3DC6C3",
          "#50E3C2",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value;
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const exportCsv = () => {
    const headers = [
      "brand", // Assuming 'brand' is equivalent to 'store' in your case
      "store",
      "start_date",
      "end_date",
      "category",
      "count",
    ];
    // Prepare data for CSV
    const data = [
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Loyalist",
        count: loyalistCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Potential Loyalist",
        count: potentialLoyalistCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Promising",
        count: promisingCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Hesitant",
        count: hesitantCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Loyalist",
        count: loyalistCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Need Attention",
        count: needAttentionCount,
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Detatractors",
        count: detractorsCount,
      },

      // ... [rest of your categories]
    ];

    // Convert to CSV
    const csv = Papa.unparse({
      fields: headers,
      data: data,
    });

    // Create a Blob from the CSV String
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "customer_categories.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const chartId = 40;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h2 className="fw-bold text-capitalize">
          <span style={{ color: "#83c14a" }}>Customer</span>
          <span style={{ color: "black" }}> Count</span>
        </h2>
        <Export exportCsv={exportCsv} exportPdf={() => printChart(chartId)} />
      </div>
      <div className="row">
        <div className="col-sm-4 mb-3" style={{ maxWidth: "max-content" }}>
          <DateRangeReport onChange={onChangeDate} field={dateField} />
        </div>
        <div className="col-sm-4 mb-3">
          <Select
            options={[
              { value: "AllStore", label: "All Store" },
              ...store.map((store) => ({
                value: store.name,
                label: store.name,
              })),
            ]}
            onChange={(selectedOption) => onChangeStore(selectedOption?.value)}
            isDisabled={!range}
            placeholder="Select Store"
          />
        </div>
      </div>

      {transactions.length > 0 ? (
        <div id="40">
          <div className="card">
            <Bar data={data} options={options} />
          </div>
          <div className="print-only-content">
            <h2>Report Details</h2>
            <div className="print-only-content">
              <div>
                <h3>Brand: Angels Pizza</h3>
                <h3>Store: {selectedStore}</h3>
                <h3>
                  Date: {startDate} - {endDate}
                </h3>
              </div>
            </div>
            <div style={{ fontSize: "20px" }}>
              <table className="table text-center">
                <thead>
                  <tr className="d-flex">
                    <th>Type</th>
                    <th className="ms-5">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.labels.map((label, index) => (
                    <tr className="d-flex" key={label}>
                      <td>{label}</td>
                      <td>{data.datasets[0].data[index]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : !storess || !range ? (
        <div className="text-center align-items-center mt-4">
          <img
            src="./choosefirst.png"
            style={{ height: "200px", width: "200px" }}
          />
          <h4 className="mt-4 fw-semibold text-muted text-center">
            👋 To get started, please select a{" "}
            <span className="text-success">date range</span> and{" "}
            <span className="text-success">store</span> above.
          </h4>
        </div>
      ) : notFound ? (
        <div className="text-center mt-5">
          <p className="text-muted fs-5">
            📭 Data not found for selected filter.
          </p>
        </div>
      ) : (
        <div className="text-center mt-5">
          <DefaultState />
        </div>
      )}
    </>
  );
}

export default CustomerCountPage;
